import React from 'react'

import { FormErrorMessage } from 'components/reusables/formErrorMessage'

interface IProps {
  text: React.ReactNode
}

const ErrorField: React.FC<IProps> = ({ text }) => {
  return <FormErrorMessage message={text || undefined} />
}

export default ErrorField
